module.exports = __webpack_public_path__ + "img/create-treatment-button-mobile-fr.014a807a.jpg";